import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bdb7672"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "packingwiz-wrapper" }
const _hoisted_4 = { class: "input-rows" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Bagageguide", -1))
const _hoisted_6 = { class: "category-radiobuttons" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "radiobuttons_3" }
const _hoisted_9 = { class: "radiobutton" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "storstad", -1))
const _hoisted_11 = { class: "radiobutton" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mixed" }, "Mixat", -1))
const _hoisted_13 = { class: "radiobutton" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "countryside" }, "Landsbygd", -1))
const _hoisted_15 = { class: "category-radiobuttons" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "radiobuttons_3" }
const _hoisted_18 = { class: "radiobutton" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "Mindre än 1 vecka", -1))
const _hoisted_20 = { class: "radiobutton" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mixed" }, "1 - 3 veckor", -1))
const _hoisted_22 = { class: "radiobutton" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "countryside" }, "Mer än 3 veckor", -1))
const _hoisted_24 = { class: "category-radiobuttons" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "radiobuttons_2" }
const _hoisted_27 = { class: "radiobutton" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "Mycket resande, korta stopp", -1))
const _hoisted_29 = { class: "radiobutton" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mixed" }, "Lite resande, långa stopp", -1))
const _hoisted_31 = { class: "wizard-list-grid" }
const _hoisted_32 = { class: "category-title" }
const _hoisted_33 = { class: "itemlist" }

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import DocumentIcon from "../../../assets/SVG/documentIcon.vue";
import SoapIcon from "../../../assets/SVG/soapIcon.vue";
import CardsIcon from "../../../assets/SVG/cardsIcon.vue";
import TechIcon from "../../../assets/SVG/TechIcon.vue";
import ClothesIcon from "../../../assets/SVG/ClothesIcon.vue";
import EtcIcon from "../../../assets/SVG/EtcIcon.vue";
import meta from "@/data/meta.json";
import { reactive, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PackingGuide',
  setup(__props) {

const packingBase = [
	{
		title: "Resehandlingar",
		icon: DocumentIcon,
		items: [
			{
				item: "Bankkort",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "EU-kort från Försäkringskassan",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Reseförsäkringshandlingar",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Hotellbokningar",
				tags: {
					enviornment: ["mix", "landsbygd", "storstad", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Hyrbilsbokningar",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Offlinekarta",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Pass",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Utländsk valuta",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
		],
	},
	{
		title: "Hygienartiklar",
		icon: SoapIcon,
		items: [
			{
				item: "Deoderant",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Parfym",
				tags: {
					enviornment: ["mix", "storstad", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Handduk",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Hårstyling",
				tags: {
					enviornment: ["mix", "storstad", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Kam/Borste",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Lypsyl",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Hudkräm",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Nagelsax",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Pincett",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Rakningstillbehör",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Schampo & Tvål",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Smink",
				tags: {
					enviornment: ["mix", "storstad", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Solskydd",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tandborste",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tandkräm",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tandtråd",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Toalettpapper",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Våtservetter",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Handsprit",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
		],
	},
	{
		title: "Underhållning",
		icon: CardsIcon,
		items: [
			{
				item: "Böcker",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Kortlek",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Korsordstidning",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Hörlurar (gärna med brusreducering)",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Simglasögon / Snorkel",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
		],
	},
	{
		title: "Elektronik",
		icon: TechIcon,
		items: [
			{
				item: "Reseadapter",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tejp, förslagsvis silvertejp",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Mobiltelefon",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Mobilladdare",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Powerbank",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", null],
				},
			},
		],
	},
	{
		title: "Kläder",
		icon: ClothesIcon,
		items: [
			{
				item: "Underkläder",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "T-shirts",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Shorts",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Badkläder",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tjocktröja",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "En findress",
				tags: {
					enviornment: ["mix", "storstad", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Långbyxor",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Lämpliga skor",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Vandringskängor",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Sandaler",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Regnkläder",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
		],
	},
	{
		title: "Övrigt",
		icon: EtcIcon,
		items: [
			{
				item: "Adresslista",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Glasögon",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Keps",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Klocka",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Kniv",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["3", null],
					stopDuration: ["long", null],
				},
			},
			{
				item: "Korkskruv & Kapsylöppnare",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Liten ryggsäck",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Värktabletter",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Vätskeersättning",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Första hjälpen kit",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Allergimedicin",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Multiverktyg",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["long", null],
				},
			},
			{
				item: "Myggmedel",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Nål & tråd",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Papper & penna",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Påsar i olika storlekar",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Reseguider",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Skavsårsplåster",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tofs",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tändare/tändstickor",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Vattenflaska",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Vattentät säck/påse",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Hänglås",
				tags: {
					enviornment: ["mix", "storstad", "landsbygd", null],
					duration: ["1", "2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tvättlina",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
			{
				item: "Tvättmedel",
				tags: {
					enviornment: ["mix", "landsbygd", null],
					duration: ["2", "3", null],
					stopDuration: ["short", "long", null],
				},
			},
		],
	},
];

const state = reactive({
	PackingObject: [...packingBase],
	terrain: "",
	travelLength: "",
	stopDuration: "",
});

function handleSelection() {
	var output = JSON.parse(JSON.stringify(packingBase)) as typeof packingBase;
	output.forEach((category) => {
		if (state.terrain) {
			category.items = category.items.filter((item) => {
				return item.tags.enviornment.includes(state.terrain);
			});
		}

		if (state.travelLength) {
			category.items = category.items.filter((item) => {
				return item.tags.duration.includes(state.travelLength);
			});
		}

		if (state.stopDuration) {
			category.items = category.items.filter((item) => {
				return item.tags.stopDuration.includes(state.stopDuration);
			});
		}
	});

	state.PackingObject = [...output];
}

watch(
	() => [state.terrain, state.travelLength, state.stopDuration],
	() => {
		handleSelection();
	}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).bringOnTrip), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Packning",
      backgroundImageClass: "background-champs-elysees"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, {
          "header-tag": "h2",
          header: "\n            Något utav de besvärligare momenteten inför en resa är packningen där man behöver bestämma sig för vad som ska med och vad som skall lämnas hemma. Man vill å ena sidan inte packa för mycket, men å andra sidan inte heller skära ner på nödvändigheter. I denna guide hjälper vi dig med din packning."
        }),
        _createVNode(TextBlock, {
          header: "Vad ska man packa i?",
          content: "Något som är väldigt svårt att veta innan man genomfört en resa är vad man ska packa i. Vad det står mellan är väl resväska, eller ryggsäck. Sedan kommer man dessutom till frågeställningen om hur stor denna skall vara. Att svara på dessa frågor är inte enkelt och svaret varierar naturligtvis beroende på resa, men även mellan olika personer. För att göra det enkelt skiljer vi olika resor åt beroende på terräng, resemängd och reselängd."
        }),
        _createVNode(TextBlock, { header: "Vad ska man ta med?" }, {
          default: _withCtx(() => [
            _createTextVNode(" Packningen beror förstås mycket på hur länge du planerar vara borta. Det är en stor en stor skillnad på en vecka och en månad, men vi anser inte att du bör packa mera kläder för det. Kläder väger mycket och tar dessutom stor plats. Istället bör du packa kläder för en vecka och ta med tvättmedel för en månad. En mycket bra lösning. "),
            _hoisted_1,
            _hoisted_2,
            _createTextVNode(" Plastpåsar får du inte glömma. De är jättelätta, små och kan vara hur nödvändiga som helst. Planerar du att utforska naturen med din packning, eller om regnet öser ner är det riktigt bra att ha plockat ner all packning i plastpåsar inuti väskan för att minimera risken att packningen blir blöt. Dessutom håller packningen sig flytande om den skulle tappas i vatten och kan det vara praktiskt att förvara smutstvätt i en plastpåse. ")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, "Terräng - " + _toDisplayString(state.terrain), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "city",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.terrain) = $event)),
                    value: "storstad"
                  }, null, 512), [
                    [_vModelRadio, state.terrain]
                  ]),
                  _hoisted_10
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "mixed",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.terrain) = $event)),
                    value: "mix"
                  }, null, 512), [
                    [_vModelRadio, state.terrain]
                  ]),
                  _hoisted_12
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "countryside",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.terrain) = $event)),
                    value: "landsbygd"
                  }, null, 512), [
                    [_vModelRadio, state.terrain]
                  ]),
                  _hoisted_14
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, "Reslängd - " + _toDisplayString(state.travelLength), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "city",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.travelLength) = $event)),
                    value: "1"
                  }, null, 512), [
                    [_vModelRadio, state.travelLength]
                  ]),
                  _hoisted_19
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "mixed",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.travelLength) = $event)),
                    value: "2"
                  }, null, 512), [
                    [_vModelRadio, state.travelLength]
                  ]),
                  _hoisted_21
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "countryside",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.travelLength) = $event)),
                    value: "3"
                  }, null, 512), [
                    [_vModelRadio, state.travelLength]
                  ]),
                  _hoisted_23
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, "Resmängd - " + _toDisplayString(state.stopDuration), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "city",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.stopDuration) = $event)),
                    value: "short"
                  }, null, 512), [
                    [_vModelRadio, state.stopDuration]
                  ]),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "mixed",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.stopDuration) = $event)),
                    value: "long"
                  }, null, 512), [
                    [_vModelRadio, state.stopDuration]
                  ]),
                  _hoisted_30
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.PackingObject, (category, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${index}-${category.title}`
              }, [
                _createElementVNode("div", _hoisted_32, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(packingBase[index].icon))),
                  _createElementVNode("b", null, _toDisplayString(category.title), 1)
                ]),
                _createElementVNode("ul", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.items, (item, index2) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `${index}-${index2}-${item.item}`
                    }, _toDisplayString(item.item), 1))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})